import React from "react";
import { DisplayMode } from "core/codegen/types";
import { ContentView } from "./ContentView";
import { FullscreenView } from "./FullscreenView";
export var prepProvider = function (SlotViewImpl) {
    return function (_a) {
        var data = _a.data;
        var page = data;
        if (page.embed === null)
            return React.createElement(SlotViewImpl, { data: page });
        switch (page.embed.displayMode) {
            case DisplayMode.Fullscreen:
                return React.createElement(FullscreenView, { data: page });
            case DisplayMode.Content:
                return React.createElement(ContentView, { data: page });
            case DisplayMode.Slot:
                return React.createElement(SlotViewImpl, { data: page });
        }
    };
};
